import type { NavigateFunction, Location } from "react-router-dom";
import { createContext, useContext } from "react";

export interface IRouterContext {
  navigate: NavigateFunction;
  location?: Location;
}

export interface ITokenContext {
  accessToken: string;
}

export interface IIntakeAuthenticatedUser {
  email: string;
  username: string;
  // Whether ENABLE_LIBERTY_REFERRAL_FIELDS was on at login time -- this auth
  // path has no accessToken, so it can't fetch /api/v1/constants/ like the
  // main app does; the backend piggybacks the flag onto the login response
  // instead. Optional: cached localStorage payloads from before this field
  // existed won't have it, and should be treated as "off" (Boolean(...)).
  libertyReferralFieldsEnabled?: boolean;
}

export interface IIntakeTokenContext {
  intakeToken: string | null;
  setIntakeToken: (token: string | null) => void;
  // The externally-authenticated intake user (referring-party login flow) --
  // distinct from the main app's loggedInUser, which only populates for the
  // staff accessToken flow.
  intakeUser: IIntakeAuthenticatedUser | null;
  setIntakeUser: (user: IIntakeAuthenticatedUser | null) => void;
}

export const RouterContext = createContext<IRouterContext>(
  {} as IRouterContext,
);

export const TokenContext = createContext<ITokenContext>({} as ITokenContext);
export const IntakeTokenContext = createContext<IIntakeTokenContext>(
  {} as IIntakeTokenContext,
);

export const useToken = () => useContext(TokenContext);
export const useIntakeToken = () => useContext(IntakeTokenContext);
